<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="600"
  >
    <a-form
      :model="formState"
      :rules="rules"
      ref="formRef"
      :label-col="{ style: { width: '100px' } }"
    >
      <a-form-item label="反馈内容" name="feedbackContent">
        <a-input
          v-model:value="formState.feedbackContent"
          placeholder="请输入反馈内容"
        ></a-input>
      </a-form-item>
      <a-form-item label="应对措施" name="countermeasures">
        <a-textarea
          v-model:value="formState.countermeasures"
          placeholder="请输入应对措施"
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="工程对接人" name="contactPerson">
        <a-textarea
          v-model:value="formState.contactPerson"
          placeholder="请输入工程对接人"
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="图片">
        <upload-img-vue
          ref="imgRef"
          :attachment="formState.picture"
          :requestFn="uploadProduceAttachment"
        ></upload-img-vue>
      </a-form-item>
      <a-form-item label="视频">
        <upload-video-vue
          ref="videoRef"
          :attachment="formState.video"
          :requestFn="uploadProduceAttachment"
        ></upload-video-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { showUploading, hideUploading } from "@/utils/index";
import {
  saveOrUpdateWIRecord,
  uploadProduceAttachment,
} from "@/request/view/product";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";

export default defineComponent({
  components: { uploadImgVue, uploadVideoVue },
  props: {
    type: String,
    produceOrTpc: String,
  },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });
    const imgRef = ref();
    const videoRef = ref();

    const formState = reactive({
      id: null,
      feedbackContent: null,
      countermeasures: null,
      localDate: null,
      contactPerson: null,
      produceOrTpc: null,
      picture: null,
      video: null,
      type: null,
      project: "swan",
      reason: null,
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加质检数据") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {
      feedbackContent: [
        {
          required: true,
          message: "请输入反馈内容",
          trigger: "change",
          type: "string",
        },
      ],
      // countermeasures: [
      //   {
      //     required: true,
      //     message: "请输入应对措施",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // contactPerson: [
      //   {
      //     required: true,
      //     message: "请输入工程对接人",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addSop") {
        modalConfig.title = "添加作业指导书及其记录表反馈";
        formState.localDate = timeStampToTime("", "upload");
        const { id, username } = store.state.user.user;
        formState.userId = id;
        formState.username = username;
        formState.type = props.type;
        formState.project = "swan";
        formState.produceOrTpc = props.produceOrTpc;
      } else if (type === "editSop") {
        modalConfig.title = "编辑作业指导书及其记录表反馈";
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            showUploading();
            await imgRef.value
              .uploadFile()
              .then((res) => {
                formState.picture = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await videoRef.value
              .uploadFile()
              .then((res) => {
                formState.video = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await saveOrUpdateWIRecord(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
                hideUploading();
              })
              .catch((err) => {
                console.log(err);
                hideUploading();
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      formState,
      props,
      rules,
      isEdit,
      imgRef,
      videoRef,
      uploadProduceAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
